import { render, staticRenderFns } from "./IllionAdrUploader.vue?vue&type=template&id=6b479516&scoped=true&"
import script from "./IllionAdrUploader.vue?vue&type=script&lang=js&"
export * from "./IllionAdrUploader.vue?vue&type=script&lang=js&"
import style0 from "./IllionAdrUploader.vue?vue&type=style&index=0&id=6b479516&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b479516",
  null
  
)

export default component.exports